import apiClient from './apiClient';

export const budgetsApi = {
  // Get budget templates
  getBudgetTemplates: (incomeRange) => apiClient.get('/budget/templates', { params: { incomeRange } }),

  // Generate AI budget
  generateAIBudget: (budgetData) => apiClient.post('/budget/ai-generate', budgetData),

  // Create user budget
  createUserBudget: (budgetData) => apiClient.post('/budget/create', budgetData),

  // Get user budgets
  getUserBudgets: (params = {}) => apiClient.get('/budgets', { params }),

  // Get specific budget details
  getBudgetDetails: (budgetId) => apiClient.get(`/budgets/${budgetId}`),

  // Update budget
  updateBudget: (budgetId, budgetData) => apiClient.put(`/budgets/${budgetId}`, budgetData),

  // Delete budget
  deleteBudget: (budgetId) => apiClient.delete(`/budgets/${budgetId}`),

  // Track spending
  trackSpending: (budgetId, spendingData) => apiClient.post(`/budget/${budgetId}/track`, spendingData),

  // Get spending entries
  getSpendingEntries: (budgetId, params = {}) => apiClient.get(`/budget/${budgetId}/spending`, { params }),

  // Update spending entry
  updateSpendingEntry: (budgetId, entryId, entryData) => apiClient.put(`/budget/${budgetId}/spending/${entryId}`, entryData),

  // Delete spending entry
  deleteSpendingEntry: (budgetId, entryId) => apiClient.delete(`/budget/${budgetId}/spending/${entryId}`),

  // Get budget analysis
  getBudgetAnalysis: (budgetId, period = 'monthly') => apiClient.get(`/budget/${budgetId}/analysis`, { params: { period } }),

  // Get spending categories
  getSpendingCategories: () => apiClient.get('/budget/categories'),
};

export default budgetsApi;
